import { render, staticRenderFns } from "./breathResponse.vue?vue&type=template&id=694cd1f8&scoped=true&"
import script from "./breathResponse.vue?vue&type=script&lang=js&"
export * from "./breathResponse.vue?vue&type=script&lang=js&"
import style0 from "./breathResponse.vue?vue&type=style&index=0&id=694cd1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694cd1f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694cd1f8')) {
      api.createRecord('694cd1f8', component.options)
    } else {
      api.reload('694cd1f8', component.options)
    }
    module.hot.accept("./breathResponse.vue?vue&type=template&id=694cd1f8&scoped=true&", function () {
      api.rerender('694cd1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/components/breathResponse.vue"
export default component.exports